WiseMetering.Views.ShowWiseApiConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/wise_api/show',
    title: () => i18next.t('modal.title.integration_configurations.show'),

    edit: function() {
        new WiseMetering.Views.EditWiseApiConfiguration({ model: this.model });
    },

    onShow: function() {
        // The access token is only serialized by the show endpoint, and only for
        // administrators - the index the table is built from never carries it.
        if (!WiseMetering.currentUser.isAdministrator()) {
            return;
        }

        this.model.fetch().always(() => {
            this.accessTokenFetched = true;

            if (this.isClosed) {
                return;
            }

            this.render();
            this.modal.redraw(true);
        });
    },

    serializeData: function() {
        const isAdministrator = WiseMetering.currentUser.isAdministrator();

        return {
            ...this.model.toJSON(),
            // Set explicitly: the show endpoint omits it when there is none, and the
            // template would blow up on an absent key.
            access_token: this.model.get('access_token'),
            fetchingAccessToken: isAdministrator && !this.accessTokenFetched,
            showAccessToken: isAdministrator
        };
    }
});
